import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  Input,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { EntityDispatch } from "../../picking-shared";
import {
  EntityPickingService,
  isEmptyObject,
  User,
  AuthService,
} from "../../../core";
import { tap } from "rxjs/operators";
import { MatExpansionPanel } from "@angular/material/expansion";

@Component({
  standalone: false,
  selector: "app-picking-productivity-filter",
  templateUrl: "./picking-productivity-filter.component.html"
})
export class PickingProductivityFilterComponent implements OnInit {
  @Input() clearFlag: boolean = false;
  /**
   * Entities  of picking productivity filter component
   */
  entities: EntityDispatch[] = [];
  /**
   * Form  of picking productivity filter component
   */
  formStart: FormGroup;
  /**
   * User  of picking orders filter component
   */
  user: User;
  /**
   * View child of picking order dispatch filter component
   */
  @ViewChild("filters") filterPanel: MatExpansionPanel;
  /**
   * Output  of picking order dispatch filter component
   */
  @Output() changeFilterValues: EventEmitter<any> = new EventEmitter();
  /**
   * Output  of picking productivity filter component
   */
  @Output() change: EventEmitter<any> = new EventEmitter();
  /**
   * Creates an instance of picking productivity filter component.
   * @param _fb FormBuilder
   * @param entityPickingService EntityPickingService
   */
  constructor(
    private _fb: FormBuilder,
    private entityPickingService: EntityPickingService,
    private authService: AuthService
  ) {
    this.startForm();
  }
  /**
   * on init
   */
  ngOnInit() {
    this.user = this.authService.getUser();
    this.showEntities().subscribe((res: any) => {
      if (res.length > 0) {
        const entityIds = res
          .filter((x) => x.entityId === this.user.entity.entityId)
          .map((x) => x.entityId);
        this.formStart.controls['entity'].setValue(entityIds || null);
      }
    });
  }
  /**
   * Determines whether change entity on
   */
  onChangeEntity() { }
  /**
   * Determines whether change filter on
   */
  onClickFilter() {
    this.filterPanel.close();
    const filter = this.formStart.value;
    this.changeFilterValues.emit(isEmptyObject(filter));
  }
  /**
   * Determines whether change period on
   */
  onChangePeriod(event: any) {
    this.formStart.controls['period'].setValue(event);
    const filter = this.formStart.value;
    this.change.emit(isEmptyObject(filter));
  }
  formResetValues() {
    this.formStart.reset({
      entity: null,
      period: null,
    });
  }
  /**
   * Starts form
   */
  private startForm() {
    this.formStart = this._fb.group({
      entity: [null, [Validators.required]],
      period: [null, [Validators.required]],
    });
  }
  /**
   * Shows entities
   */
  private showEntities() {
    return this.entityPickingService.getAll().pipe(
      tap((res: any) => {
        this.entities = res;
      })
    );
  }

  clearDateRange() {
    this.clearFlag = !this.clearFlag;
  }
}
